<template>
  <!-- <ex-card disable-offsets class="product_list_table" v-if="show_selected_product_table"> -->
  <div v-if="show_selected_product_table">

    <!-- <template slot="header"> -->
      <!-- <div v-for="(product, index) in selectedProductList" :key="index"> --> <!-- that worked when was specs[0] -->
        <div v-if="conflict_ids.length > 0">
          <div v-for="(conflict_product_id,conflict_index) in conflict_ids" :key="conflict_index">
            <ConflictCard
              :current_conflict_product_id="parseInt(conflict_product_id)"
              :conflict_index="conflict_index"
            />
          </div>
        </div>
        <ValidsTable v-if="$store.state.productionModule.valid_domains_urls.length" @success_save_all_new_urls="$emit('reloadProduct')" />
        <ProductDetailsTable2 @reload_product="$emit('reloadProduct')" />
        <EmptyDomainsTable v-if="show_empty_domains" @success_linking="$emit('reloadProduct')" />

      <!--      <div class="d-flex align-center">-->
      <!--        <v-radio-group @change="updateProductList()" ref="radioGroup" :value="selectedProductList.clients[0].client_name" row class="mt-0 pa-0" hide-details>-->
      <!--          <v-radio :label="selectedProductList.clients[0].client_name" value="0" :ripple="false" color="primary" class="i-v-radio light"></v-radio>-->
      <!--        </v-radio-group>-->
      <!--        <v-btn-->
      <!--          text-->
      <!--          :ripple="false"-->
      <!--          class="ex-btn ex-primary-btn"-->
      <!--          @click="createProduct()"-->
      <!--        >-->
      <!--          <v-icon>add</v-icon>-->
      <!--        </v-btn>-->
      <!--      </div>-->
    <!-- </template> -->
    <v-dialog v-model="deleteDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Deleting, are you sure?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            :ripple="false"
            :loading="loading"
            class="ex-btn ex-primary-btn text--white"
            @click="deleteDialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
            :ripple="false"
            :loading="loading"
            class="ex-btn ex-primary-btn text--white"
            @click="confirmDeleteLink()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn
      v-if="showButton"
      v-on:click="goToTop"
      fixed
      bottom
      right
      depressed
      fab
      color="blue-grey  darken-1"
      class="go_top_btn yellow--text"
    ><v-icon>north</v-icon>
    </v-btn>
  </div>
  <!-- </ex-card> -->
</template>

<script>
/* eslint-disable */
// import ProductDetailsHeader from "./N_ProductDetailsHeader"; // link and unlink
import ProductDetailsInfo from "./N_ProductDetailsInfo";
import ProductDetailsTable from "./N_ProductDetailsTable";
import ProductDetailsTable2 from "./N_ProductDetailsTable2";
import EmptyDomainsTable from "./N_EmptyDomainsTable";
import ResolveConflictTable from "./N_ResolveConflictTable.vue";
import ConflictCard from "./N_ConflictCard.vue";
import ValidsTable from "./N_ValidsTable.vue";

export default {
  name: "N_ProductTable",
  components: {
    ConflictCard,
    ResolveConflictTable,
    ValidsTable,
  //   ProductDetailsHeader,
    ProductDetailsInfo,
    ProductDetailsTable,
    ProductDetailsTable2,
    EmptyDomainsTable,
  },
  computed: {
    // show_selected_product_table () {
    //   // return this.$store.getters.show_selected_product_test;
    //   return this.$store.state.productionModule.loaded_products
    //           .map( product => product.product_id )
    //           .includes( this.$store.state.productionModule.selected_product.id )
    // },
    show_selected_product_table () {
      return this.$store.getters['productionModule/show_selected_product_table'];
    },
    showConflict() { return this.$store.state.productionModule.showConflict },
    conflict_ids() {return this.$store.state.productionModule.products_ids_with_conflict },
    invalids() {
      return ((this.$store.state.productionModule.conflict_temporary_urls.invalid.duplicate_products)
              ? this.$store.state.productionModule.conflict_temporary_urls.invalid.duplicate_products
              : [])
      },
    selectedProductList() { return this.$store.state.productionModule.selected_product.specs },
    selectVariation() { return ['color', 'size'] },
    trackIds() { return [] },
    urlIds() { return [] },
    deleteUrlPayload() { return [] },
    productInfo() { return {
      client_id: this.$store.state.productionModule.product_filter.selected_client,
      product_id: this.$store.state.productionModule.selected_product.id,
      info: this.$store.state.productionModule.selected_product.specs.product_info
    } },
    productsData() {
      return this.$store.state.productionModule.loaded_products
              .find(product_item => product_item.product_id === this.productInfo.product_id)
    },//this.$store.getters.productionModule.selected_product_item
    show_empty_domains() {
      return ( this.productInfo.info && this.productInfo.info.list ) ? !!this.productInfo.info.list : false
    }
  },
  data: () => ({
    loading: false,
    dialog: false,
    linkDialog: false,
    deleteDialog: false,
    trackId: [],
    selected: [],
    showButton: false,
  }),
  mounted() {
    console.log("SELECTED PRODUCTs", this.selectedProductList);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    parentProduct(id) { // alert(id)
      this.$emit('parentProduct',id);
      //this.$parent.loadProduct(id);
    },
    updateProductList() {
      let coped = JSON.stringify(this.selectedProductList);
      let copyObject = JSON.parse(coped);
      let trackIds = [];
      let arr = [];
      copyObject.clients.forEach((el, index) => {
        el.tracks.map((el) => trackIds.push(el.track_id));
      });
      copyObject.tracks.map((copyEl) => {
        let tracksItems = copyEl;
        copyEl.urls.map((el) => {
          let urls = [];
          trackIds.forEach((checkElement) => {
            if (el.track_id === checkElement) {
              urls.push(el);
              let createCheckedObj = {
                urls,
                color: 1,
                seller_id: tracksItems.seller_id,
                seller_name: tracksItems.seller_name,
              };
              arr.push(createCheckedObj);
            }
          });
        });
      });
      this.selectedProductList.tracks = arr;
    },
    selectItem({ trackId, urlId, domainId, productId }) {
      const mainCheckbox = document.getElementById(domainId);
      const allCheckbox = document.querySelectorAll(`.domain_${domainId}`);

      for (const checkbox of allCheckbox) {
        if (!checkbox.checked) {
          mainCheckbox.checked = false;
          break;
        }
        mainCheckbox.checked = true;
      }
      this.$emit("createPayloadLinkFromClients", trackId, urlId);
    },
    selectSeller(e, domains) {
      // const isChecked = e.target.checked
      this.checkAllOfCurrentTable(e.target);
      domains.forEach((domain) => {
        domain.sellers.forEach((seller) => {
          this.$emit(
            "createPayloadLinkFromClients",
            seller.track_id,
            domain.url_id
          );
        });
      });
    },
    checkAllOfCurrentTable(target) {
      const elements = target
        .closest(".domain_table")
        .querySelectorAll(".track_checkbox");
      // console.log(this.$refs.ProductDetailsTable)
      elements.forEach((el) => {
        // el.checked = target.checked
        this.$set(el, "checked", target.checked);
        // console.log(childCheckbox)
      });
    },
    onCheckedAll(isChecked) {
      const elements = document.querySelectorAll(".track_checkbox");
      elements.forEach((element) => {
        if (isChecked) {
          if (element.checked) return;
          element.checked = true;
        } else {
          element.checked = false;
        }
      });
    },
    callSelectedAll(e) {
      let input = document.getElementsByClassName("custom-checkbox");
      if (e.target.checked) {
        this.trackIds = [];
        this.selectedProductList.tracks.map((el) => {
          el.urls.map((elem) => {
            this.trackIds.push(elem.track_id);
          });
        });
        Array.from(input).forEach((el) => {
          el.checked = true;
        });
      } else {
        this.trackIds = [];
        Array.from(input).forEach((el) => {
          el.checked = false;
        });
      }
    },
    createProduct() {
      this.$emit("createProduct");
    },
    confirmDelete() {
      this.loading = true;
      this.dialog = false;
      this.$store
        .dispatch("productModule/deleteRowOfProductList", this.productInfo)
        .then((res) => {
          console.log("deleteRowOfProductList", res);
          this.loading = false;
        });
    },
    confirmDeleteLink() {
      this.$emit("deleteLinks", this.trackId);
      this.deleteDialog = false;
    },
    deleteLink(trackId) {
      this.trackId = [trackId];
      this.deleteDialog = true;
    },
    handleScroll() {
      const scrollPos = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollPos > 0) {
        this.showButton = true;
      } else {
        this.showButton = false;
      }
    },
    goToTop() {
      console.log('window.pageYOffset',window.pageYOffset )
      console.log('document.documentElement.scrollTop',document.documentElement.scrollTop)
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.product_info_content {
  flex-wrap: wrap;
}

.product_info_content > .product_info > p:first-child {
  border-bottom: 1px solid;
}

.go_top_btn {
  /* position: fixed;
  bottom: 20px;
  right: 20px; */
  /* width: 300px; */
  /* z-index: 1; */
  opacity: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/production/N_ProductTable.vue